import { render, staticRenderFns } from "./leadLovers.vue?vue&type=template&id=01a2ca84&scoped=true"
import script from "./leadLovers.vue?vue&type=script&lang=js"
export * from "./leadLovers.vue?vue&type=script&lang=js"
import style0 from "./leadLovers.vue?vue&type=style&index=0&id=01a2ca84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2ca84",
  null
  
)

export default component.exports